import { FC } from 'react';

import { ActEditingField } from 'utils/constants/admin';

import useTrls from 'hooks/translation/useTrls';

import { EditingData } from 'components/Admin/Reports/ActsReport/EditingActsTable/EditingAct/EditingAct';
import EditingField from 'components/Admin/Reports/ActsReport/EditingActsTable/EditingAct/EditingField';

import { Act } from 'store/models/acts';

import styles from 'components/Admin/Reports/ActsReport/ActsTable/Act/Act.module.less';

interface PeriodProps {
    act: Act;
    onChange: (field: ActEditingField, value: string | undefined) => void;
    values: EditingData;
    canEditing?: boolean;
}

const Period: FC<PeriodProps> = ({ act, onChange, values, canEditing = true }) => {
    const { periodStart: editingPeriodStart, period: editingPeriodEnd, actDate: editingActDate } = values;
    const { period, periodStart, actDate } = act;

    const trl = useTrls();

    if (!canEditing) {
        return (
            <>
                <div className={styles.tableCellGroup}>
                    <b>{trl('admin.actsReport.actsTable.label.periodStart')}: </b>
                    {periodStart}
                </div>
                <div className={styles.tableCellGroup}>
                    <b>{trl('admin.actsReport.actsTable.label.periodEnd')}: </b>
                    {period}
                </div>
                <div className={styles.tableCellGroup}>
                    <b>{trl('admin.actsReport.actsTable.label.actDate')}: </b>
                    {actDate}
                </div>
            </>
        );
    }

    return (
        <>
            <div className={styles.tableCellGroup}>
                <b>{trl('admin.actsReport.actsTable.label.periodStart')}: </b>
                <EditingField
                    value={periodStart}
                    newValue={editingPeriodStart}
                    setNewValue={(value) => {
                        onChange(ActEditingField.PeriodStart, value);
                    }}
                    resetNewValue={() => {
                        onChange(ActEditingField.PeriodStart, undefined);
                    }}
                    size="small"
                >
                    {periodStart}
                </EditingField>
            </div>
            <div className={styles.tableCellGroup}>
                <b>{trl('admin.actsReport.actsTable.label.periodEnd')}: </b>
                <EditingField
                    value={period}
                    newValue={editingPeriodEnd}
                    setNewValue={(value) => {
                        onChange(ActEditingField.PeriodEnd, value);
                    }}
                    resetNewValue={() => {
                        onChange(ActEditingField.PeriodEnd, undefined);
                    }}
                    size="small"
                >
                    {period}
                </EditingField>
            </div>
            <div className={styles.tableCellGroup}>
                <b>{trl('admin.actsReport.actsTable.label.actDate')}: </b>
                <EditingField
                    value={actDate}
                    newValue={editingActDate}
                    setNewValue={(value) => {
                        onChange(ActEditingField.ActDate, value);
                    }}
                    resetNewValue={() => {
                        onChange(ActEditingField.ActDate, undefined);
                    }}
                    size="medium"
                    placeholder={trl('admin.actsReport.actsTable.placeholder.actDate')}
                >
                    {actDate}
                </EditingField>
            </div>
        </>
    );
};

export default Period;
